<div class="responsive-card d-flex flex-column gap-4" *ngIf="!isLoading; else loading">
  <div class="d-flex gap-3">
    <div class="responsive-card-title flex-grow-1" i18n>Addresses</div>
    <app-tertiary-button
      [size]="BaseButtonSizeEnum.md"
      leftIconSrc="assets/icons/primary/EditIcon.svg"
      (buttonClicked)="editClicked.emit()"
      i18n>
      Edit
    </app-tertiary-button>
  </div>

  <div class="d-flex flex-column gap-4">
    <div class="section-header" i18n>Head Office Address</div>
    <div class="address-card-grid">
      <app-review-entry label="Country" [value]="employer?.headOfficeAddress?.countryName ?? ''" i18n-label />
      <app-review-entry label="Address Line 1" [value]="employer?.headOfficeAddress?.addressLine1 ?? ''" i18n-label />
      <app-review-entry label="Address Line 2" [value]="employer?.headOfficeAddress?.addressLine2 ?? ''" i18n-label />
      <app-review-entry label="Address Line 3" [value]="employer?.headOfficeAddress?.addressLine3 ?? ''" i18n-label />
      <app-review-entry label="City/Town" [value]="employer?.headOfficeAddress?.city ?? ''" i18n-label />
      <app-review-entry
        label="Province/State/Region"
        [value]="employer?.headOfficeAddress?.stateName ?? ''"
        i18n-label />
      <app-review-entry label="Postal Code/ZIP" [value]="employer?.headOfficeAddress?.postalCode ?? ''" i18n-label />
    </div>
  </div>

  <div class="d-flex flex-column gap-4">
    <div class="section-header" i18n>Mailing Address</div>
    <ng-container *ngIf="mailingAddressSameAsHeadOffice; else mailingAddressGrid">
      <div class="d-flex gap-1 align-items-center">
        <img [src]="'assets/icons/green/CheckCircle.svg'" alt="Check" i18n-alt />
        <span class="same-as-head-office" i18n>Same as Head Office</span>
      </div>
      <div class="address-card-grid">
        <app-review-entry label="To the Attention Of" [value]="employer?.mailingAddress?.attention ?? ''" i18n-label />
      </div>
    </ng-container>
    <ng-template #mailingAddressGrid>
      <div class="address-card-grid">
        <app-review-entry label="To the Attention Of" [value]="employer?.mailingAddress?.attention ?? ''" i18n-label />
      </div>
      <div class="address-card-grid">
        <app-review-entry label="Country" [value]="employer?.mailingAddress?.countryName ?? ''" i18n-label />
        <app-review-entry label="Address Line 1" [value]="employer?.mailingAddress?.addressLine1 ?? ''" i18n-label />
        <app-review-entry label="Address Line 2" [value]="employer?.mailingAddress?.addressLine2 ?? ''" i18n-label />
        <app-review-entry label="Address Line 3" [value]="employer?.mailingAddress?.addressLine3 ?? ''" i18n-label />
        <app-review-entry label="City/Town" [value]="employer?.mailingAddress?.city ?? ''" i18n-label />
        <app-review-entry
          label="Province/State/Region"
          [value]="employer?.mailingAddress?.stateName ?? ''"
          i18n-label />
        <app-review-entry label="Postal Code/ZIP" [value]="employer?.mailingAddress?.postalCode ?? ''" i18n-label />
      </div>
    </ng-template>
  </div>
</div>

<ng-template #loading>
  <div class="responsive-card">
    <lib-loading-shimmer [height]="'50rem'" [width]="'100%'" />
  </div>
</ng-template>
